import * as PIXI from "pixi.js";
import Layers from "../layers/Layers";
import { CircleInt, Coord } from "../types/Interface";
import { INITIAL_CIRCLE_RADIUS } from "../types/Config";
import generatePoints from "../utils/generatePoints";


export default class Circle extends PIXI.Container {
  private Layers = Layers.getInstance();
  private arcs: PIXI.Graphics[] = [];
  private colors: number[] = [];
  radius: number = INITIAL_CIRCLE_RADIUS;
  radians: number[] = [];
  points: Coord[] = [];

  constructor(coord: Coord, radians: number[], colors: number[]) {
    super();
    Object.assign(this, coord);
    this.radians = radians;
    this.colors = colors;

    this.addGraphics(radians.length);
    this.addToLayer();
  }
  private addToLayer = () => this.Layers.Middle.addChild(this);
  setColors = (colors: number[]) => this.colors = colors;
  setRadians = (radians: number[]) => this.radians = radians;
  addGraphics(count: number) {
    this.arcs = Array(count).fill(new PIXI.Graphics());
    this.arcs.forEach(arc => this.addChild(arc));
  }
  draw(details: CircleInt, transparent = false) {
    Object.assign(this, details);
    const alpha = transparent ? 0 : 1;
    const points = generatePoints({ x: 0, y: 0 }, this.radians, this.radius);
    this.arcs.forEach(arc => arc.clear());

    this.radians.forEach((r, rI) => {
      const lastelm = rI == this.radians.length - 1;
      const arc = this.arcs[rI]
      const point = points[rI];
      arc
        .moveTo(point.x, point.y)
        .arc(0, 0, this.radius, r, this.radians[!lastelm ? rI + 1 : 0])
        .stroke({ color: this.colors[rI], width: 5, alpha: !lastelm ? alpha : 1 });
    })
  }
}